module.exports = __webpack_public_path__ + "media/images/metronic/social/jolicloud-c182198a5a33c02e89a5cb6dca75883c.png";